<template>
  <default>
    <div class="tw-w-full">
      <bread-crumb :breadcrumbs="breadcrumbs" />

      <div v-if="!loading">
        <transition
            name="fade"
            mode="out-in"
            appear
            :duration="500"
        >
          <keep-alive exclude="CoverSummaryReview">
            <component
                v-bind:is="current"
                @to-personal-details-review="toPersonalDetailsReview"
                @to-switch-cover="toSwitchCover"
                @to-vehicle-details-review="toVehicleDetailsReview"
                @to-policy-review="toPolicyReview"
                @cover-summary-review="toCoverSummaryReview"
                @to-branch-selection-review="toBranchSelectionReview"
                @to-selecting-payment="toPaymentSelection"
                @to-make-payment="makePayment"
                v-bind="results"
            ></component>
          </keep-alive>
        </transition>
      </div>
      <v-card flat v-else class="tw-w-full tw-flex tw-justify-center tw-p-10">
        <v-progress-circular
            :size="80"
            color="primary1"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import PolicyReview from '@/components/policies/PolicyReview';
import PersonalDetailsReview from '@/components/policies/PersonalDetailsReview';
import VehicleDetailsReview from '@/components/policies/VehicleDetailsReview';
import BranchSelectionReview from '@/components/policies/BranchSelectionReview';
import MakePayment from '@/components/buy/MakePayment';
import PaymentSelection from '@/components/buy/PaymentSelection';
import SelectOption from '@/components/policies/SelectOption';
import SwitchCover from '@/components/policies/SwitchCover';
import { FB_RENEW_IT } from '@/utils/const';
import CoverSummaryReview from '@/components/policies/CoverSummaryReview';

export default {
  name: 'RenewPolicy',
  components: {
    BreadCrumb, Default, PersonalDetailsReview, PolicyReview, VehicleDetailsReview, BranchSelectionReview, MakePayment, PaymentSelection, SelectOption, SwitchCover, CoverSummaryReview,
  },
  data: (vm) => ({
    breadcrumbs: [
      {
        text: 'My Policies',
        disabled: false,
        to: { name: 'MyPolicies' },
      },
      {
        text: 'My Policy',
        disabled: false,
        to: { name: 'SinglePolicy', params: { policyNo: vm.$route.params.policyNo } },
      },
      {
        text: 'Renew Policy',
        disabled: true,
        to: { name: 'RenewPolicy', params: { policyNo: vm.$route.params.policyNo } },
      },
    ],
    current: SelectOption,
    data: {},
    policyNo: '',
    loading: true,
    vehicleData: {},
    branchData: {},
    paymentData: {},
    personalData: {},
    switchCoverData: {},
    summaryData: {},
  }),
  computed: {
    results() {
      if (this.current === BranchSelectionReview || this.current === 'BranchSelectionReview' || this.current === PolicyReview || this.current === 'PolicyReview' || this.current === SwitchCover || this.current === 'SwitchCover' || this.current === CoverSummaryReview || this.current === 'CoverSummaryReview') {
        return { renewal: this.data };
      }
      if (this.current === VehicleDetailsReview || this.current === 'VehicleDetailsReview') {
        return { renewal: this.data.data, switchedCover: this.data.switchedCover };
      }
      if (this.current === PersonalDetailsReview || this.current === 'PersonalDetailsReview') {
        return { changeCover: this.data };
      } return this.data;
    },
    quote() {
      return this.$store.getters['renewal/fetchQoute'];
    },
  },
  mounted() {
    this.$root.$on('nav-back-to', (data) => {
      if (data.currentTab === 'PaymentSelection') {
        this.data = this.paymentData;
      } else if (data.currentTab === 'BranchSelectionReview') {
        this.data = this.branchData;
      } else if (data.currentTab === 'VehicleDetailsReview') {
        this.data = this.vehicleData;
      } else if (data.currentTab === 'PolicyReview') {
        this.data = this.policyData;
      } else if (data.currentTab === 'PersonalDetailsReview') {
        this.data = this.personalData;
      } else if (data.currentTab === 'SwitchCover') {
        this.data = this.switchCoverData;
      } else if (data.currentTab === 'CoverSummaryReview') {
        this.data = this.summaryData;
      } else if (data.currentTab === 'SelectOption') {
        this.data = {};
      }
      this.current = data.currentTab;
    });

    this.policyNo = this.$route.params.policyNo;
    this.$store.dispatch('renewal/fetchRenewalClient', this.$route.params.batchNo).then(() => {
      this.$store.dispatch('getPolicy', this.$route.params.policyNo).then(() => {
        this.loading = false;
      });
    });

    this.$analytics.logEvent(FB_RENEW_IT, { product: 'Renewal Journey' });
  },
  methods: {
    toSwitchCover(data) {
      this.data = data;
      this.switchCoverData = data;
      this.current = SwitchCover;
    },
    toPersonalDetailsReview(data) {
      this.data = data;
      this.personalData = data;
      this.current = PersonalDetailsReview;
    },
    toVehicleDetailsReview(data) {
      this.data = data;
      this.vehicleData = data;
      this.current = VehicleDetailsReview;
    },
    toPolicyReview(data) {
      this.data = data;
      this.policyData = data;
      this.current = PolicyReview;
    },
    toCoverSummaryReview(data) {
      this.data = data;
      this.summaryData = data;
      this.current = CoverSummaryReview;
    },
    toBranchSelectionReview(data) {
      this.data = data;
      this.branchData = data;
      this.current = BranchSelectionReview;
    },
    toPaymentSelection(batchId) {
      this.data = { getQuote: this.quote, batchId };
      this.paymentData = { getQuote: this.quote, batchId };
      this.current = PaymentSelection;
    },
    makePayment(data) {
      this.data = data;
      this.current = MakePayment;
    },
  },
  metaInfo: {
    title: 'Renew Policy',
  },
};
</script>
